<template>
  <div id="accommodations">
    <div class="card-container">
      <div class="row row-hubs">
        <div class="col-12 d-flex justify-content-center align-items-center w-100">
          <div class="lodging-header w-100">
            <div class="header-nav">
              <div v-if="!onlyCurrentCollection" v-for="collection in collections.slice(0, 3)" :key="collection" class="header-nav-tabs">
                <div class="raleway-bold-p15 text-uppercase" 
                    :class="{ activeCard: selectedCollection === collection }" 
                    @click="selectedCollection = collection; $emit('collectionSelected', collectionsSlugs[collection])" 
                    :data-value="collection">
                  {{ collection }}
                </div>
              </div>

              <div class="d-flex flex-column align-items-center text-center">
                <h2 class="merriweather-reg-26">Nos</h2>
                <h2 class="merriweather-reg-40">Nouveautés</h2>
                <p class="merriweather-light-24 mb-1">Des adresses d'exception où chaque instant est un <span class="merriweather-light-italic-24">privilège</span></p>
              </div>

              <div v-if="!onlyCurrentCollection" v-for="collection in collections.slice(3, 6)" :key="collection" class="header-nav-tabs">
                <div class="raleway-bold-p15 text-uppercase" 
                    :class="{ activeCard: selectedCollection === collection }" 
                    @click="selectedCollection = collection; $emit('collectionSelected', collectionsSlugs[collection])" 
                    :data-value="collection">
                  {{ collection }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="container-fluid position-relative">
          <div class="d-flex flex-row flex-nowrap" ref="scroller" style="overflow: scroll; overflow-y: hidden">
            <div class="card card-body border-0" v-if="lodgings"  v-for="lodging in lodgings" :key="`${selectedCollection}-${lodging.id}`" style="min-height: auto; min-width: auto; margin-right:25px; max-width: 334px;">
              <CardProductHome data-aos="fade-up" data-aos-duration="900" :lodging="lodging" :user="isUserConnected()" @connection="$emit('connection')"></CardProductHome>
            </div>
          </div>
          <div class="flex-shrink-0 previous-slide-button circle-icon" v-if="lodgings.length" @click="scroll_left()">
            <img src="../../images/arrow-left-black.svg" alt="Previous" />
          </div>
          <div class="flex-shrink-0 next-slide-button circle-icon" v-if="lodgings.length" @click="scroll_right()">
            <img src="../../images/arrow-right-black.svg" alt="Next" />
          </div>
        </div>
      </div>
    </div>
    <div class="row d-flex align-items-center justify-content-center pt-2">
      <a class="hortense-btn-primary raleway-bold-p" :href="'/les-nouveautes-hortense'" target="_blank">{{ buttonText }}</a>
    </div>
  </div>
</template>

<script>
import CardProduct from '../../components/cards/CardProduct.vue';
import CardProductHome from "./CardProductHome.vue";
import AOS from "aos";


export default {
  name: 'AccommodationCard',
  props: {
    lodgings: Array,
    user: Object,
    wishlist: Object,
    onlyCurrentCollection: Boolean,
    buttonText: {
      type: String,
      default: 'Découvrir nos nouveautés'
    }
  },
  components: {CardProductHome, CardProduct },
  data() {
    return {
      lodgingsList: this.lodgings,
      lodgings: this.lodgings,
      lodgingsCurrentPage: 2, // starts at 2 as the first page is loaded by the parent component.
      collections: ['Romantique', 'Bien-etre', 'Famille', 'Insolite', 'City Break', 'Nature'],
      selectedCollection: null,
      collectionsSlugs: {
        'Romantique': 'sejour-romantique',
        'Bien-etre': 'sejour-spa',
        'Famille': 'sejour-en-famille',
        'Insolite': 'sejour-insolite',
        'City Break': 'city-break',
        'Nature': 'sejour-nature'
      }
    };
  },
  methods: {
    autoScroll() {
      const scroller = this.$refs.scroller;
      const step = 0.3; // Adjust step for speed
      let maxScrollLeft = scroller.scrollWidth - scroller.clientWidth;

      const frame = () => {
        if (scroller.scrollLeft >= maxScrollLeft) {
          scroller.scrollLeft = 0; // Reset scroll to start when it reaches the end
          maxScrollLeft = scroller.scrollWidth - scroller.clientWidth; // Recalculate in case of dynamic content
        } else {
          scroller.scrollLeft += step;
        }
        requestAnimationFrame(frame);
      }
      frame();
    },
    isUserConnected() {
      return this.user ? this.user : {};
    },
    scroll_left() {
      this.$refs.scroller.scrollLeft -= 220;
    },
    scroll_right() {
      this.$refs.scroller.scrollLeft += 220;
    }
  },
  mounted() {
    AOS.init();
    this.autoScroll();
  }
};
</script>

<style scoped>
#accommodations {
    padding-top: 70px;

    .circle-icon {
      width: 44px;
      height: 46px;
      border: 1px solid #F7F7F7;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }
    .previous-slide-button {
      position: absolute;
      top: 30%;
      transform: translateY(-50%);
      left: 0;
      color: #F7F7F7;
      background-color: #F7F7F7;

      i {
        color: black;
      }
    }

    .next-slide-button {
      position: absolute;
      top: 30%;
      transform: translateY(-50%);
      right: 0;
      color: #F7F7F7;
      background-color: #F7F7F7;

      i {
        color: black;
      }
    }

    .header-nav {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0 20px;
      border-radius: 10px;
      margin-bottom: 20px;

      .header-nav-tabs {
        cursor: pointer;
        color: #000000B2;

        div {
          white-space: nowrap;
          padding: 0.5rem 1rem;
        }
      }
      .activeCard {
        font-weight: 800;
        color: black;
        border-bottom: 2px solid #000;
      }
    }

    .hub-img, .hub-img-zoom {
      width: 334px !important;
      height: 277px !important;
      border-radius: 15px;
    }
  }
</style>